import { cleanAxios } from '~/axios'

export async function sendMFAEmailCode({
  email,
  accessToken,
}: {
  email: string
  accessToken: string
}) {
  return await cleanAxios.post<{
    data: { sendMFAEmailCode: { successful: boolean } }
  }>(
    '/graphql',
    {
      query:
        'mutation sendMFAEmailCode($email: String!) { sendMFAEmailCode(email: $email) { successful } }',
      variables: { email },
    },
    { headers: { Authorization: `Bearer ${accessToken}` } },
  )
}
